import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { OperatorsService } from '@autocaller_v2/services/OperatorsService';
import ItemForm from '@autocaller_v2/components/modal-operators-create-edit-form';
import i18n from '@app/plugins/i18n';

class OperatorsModalService extends ModalService {
  constructor() {
    super(OperatorsService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('autocaller_v2.operators.modal.remove.content', {
        type: `<strong>${item.login}</strong>`
      })
    });
  }

  change_status(state, id) {
    const state_key = state ? 'enable' : 'disable';
    const content = i18n.t(`autocaller_v2.operators.modal.change_status.${state_key}`);
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content,
      onOk: () => {
        OperatorsService.editItem(id, { active: state })
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch(e => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          })
          .finally(() => {
            this.$emit('finally');
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }

  edit(id, item) {
    return this.$open({
      title: i18n.t('autocaller_v2.operators.modal.edit'),
      width: this.size.default_plus,
      loading: true,
      render: h =>
        h(ItemForm, {
          props: {
            id: id,
            item: item
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create() {
    return this.$open({
      title: i18n.t('autocaller_v2.operators.modal.create'),
      width: this.size.default_plus,
      loading: true,
      render: h =>
        h(ItemForm, {
          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new OperatorsModalService();
export { instance as OperatorsModalService };
